<template>
    <b-alert 
        show dismissible
        variant="warning" 
        class="text-dark"
        v-if="isVisible()"
        @dismissed="closeAlert()"
    >   
        <div class="d-flex align-items-center">
            <i class="fas fa-exclamation-triangle fa-3x mr-3"></i>
            <div class="alert-heading">
                <h5>{{ trans.alert_title }}</h5>
                <strong>{{ trans.alert_desc }}</strong>
            </div>
        </div>
    </b-alert>
</template>

<script>
    export default {
        props: {
            'trans': {
                type: Object
            },
            'browser': {
                type: String
            }
        },
        methods: {
            isVisible() {
                return this.isUnsupported() && this.$cookie.get('unsupported_browser') != 1;
            },
            closeAlert() {
                this.$cookie.set('unsupported_browser', 1, { secure: true, sameSite: "lax" }); // its UI/UX only cookie, so it dont have to be secure (gettable/settable only via HTTPS)
            },
            isUnsupported() {
                return this.browser == 'IE';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/BrowserAlert.vue